import Answer from "./Answer"
import { compose } from "recompose"

Answer.defaultProps = {
  answer: "WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW",
  colors: {
    correct : {
      answerBar: "#87d082",
      font: "white",
      percentCorrectBar: "#5ab3aa",
    },
    incorrect: {
      answerBar: "#d7336c",
      font: "black",
      percentCorrectBar: "#ac2860",
    },
    neutral : {
      answerBar: "#ffffff",
      font: "black",
      percentCorrectBar: "#cfcfcf",
    },
    selected: {
      answerBar: "#eba543",
      font: "black",
      // This is null as percentCorrectBar will never be shown when 
      // selected colours are used (they only show if !isRevealed) 
      percentCorrectBar: null,
    },
  },
  isCorrect: true,
  isRevealed: true,
  isSelected: false,
  numberAnswered: 2,
  orientation: "left",
  percentAnswered: 20,
}

export default compose()(Answer)